import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { proceed } from './proceed.js';
import { getSavedTransactionMeta } from './transactionMeta.js';
import { warn } from '../util/console.js';
function poll(_x) {
  return _poll.apply(this, arguments);
}
function _poll() {
  _poll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(authClient) {
    var options,
      _a,
      transaction,
      meta,
      availablePollingRemeditaions,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          _context2.next = 3;
          return proceed(authClient, {
            startPolling: true
          });
        case 3:
          transaction = _context2.sent;
          meta = getSavedTransactionMeta(authClient);
          availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find(function (remediation) {
            return remediation.includes('poll');
          });
          if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) {
            warn('No polling remediations available at the current IDX flow stage');
          }
          if (!Number.isInteger(options.refresh)) {
            _context2.next = 9;
            break;
          }
          return _context2.abrupt("return", new Promise(function (resolve, reject) {
            setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _a, _b, refresh;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    try {
                      refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                      if (refresh) {
                        resolve(poll(authClient, {
                          refresh: refresh
                        }));
                      } else {
                        resolve(transaction);
                      }
                    } catch (err) {
                      reject(err);
                    }
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), options.refresh);
          }));
        case 9:
          return _context2.abrupt("return", transaction);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _poll.apply(this, arguments);
}
export { poll };